import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { IGeo } from '@/api/routes/geos/types';

import { fetchGeos } from './actionCreators';

interface InitialState {
  geos: IGeo [],
  isLoading: boolean,
  error: string,
}

const initialState: InitialState = {
  geos: [],
  isLoading: false,
  error: '',
};

export const geosSlice = createSlice({
  name: 'geos',
  initialState,
  reducers: {
    addNewGeo: (state, action: PayloadAction<IGeo>) => {
      state.geos = state.geos.concat(action.payload);
    },
  },
  extraReducers: {
    [fetchGeos.fulfilled.type]: (state, action: PayloadAction<IGeo []>) => {
      state.isLoading = false;
      state.error = '';
      state.geos = action.payload;
    },
    [fetchGeos.pending.type]: (state) => {
      state.isLoading = true;
    },
    [fetchGeos.rejected.type]: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export const { addNewGeo } = geosSlice.actions;
export default geosSlice.reducer;
